module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"col-md-3 prop-sublabel\" style=\"width: 75px;\">Background</div>\r\n    <div class=\"col-md-8\">\r\n        <input id=\"dialLeftColorPicker\" name=\"dialLeftColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( dialLeftColor ))
    ; __append("\"\r\n               style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\"/>\r\n        <input id=\"dialLeftColor\" name=\"dialLeftColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\"\r\n               value=\"")
    ; __append(escapeFn( dialLeftColor ))
    ; __append("\"/>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-3 prop-sublabel\" style=\"width: 75px;\">&nbsp;</div>\r\n    <div class=\"col-md-8\">\r\n        <input id=\"dialRightColorPicker\" name=\"dialRightColorPicker\" type=\"color\" value=\"")
    ; __append(escapeFn( dialRightColor ))
    ; __append("\"\r\n               style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\"/>\r\n        <input id=\"dialRightColor\" name=\"dialRightColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\"\r\n               value=\"")
    ; __append(escapeFn( dialRightColor ))
    ; __append("\"/>\r\n    </div>\r\n</div>")
  }
  return __output;

}